import { render, staticRenderFns } from "./DocContextMenu.vue?vue&type=template&id=5b7939f7&"
import script from "./DocContextMenu.vue?vue&type=script&lang=js&"
export * from "./DocContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports